// Web Audio API sound effects — no audio files needed.
// Three sounds: correct (gentle two-note), openedCorrect (warm major triad), incorrect (low descending).

let ctx = null;
let muted = false;

function getCtx() {
  if (!ctx) {
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      console.warn('Web Audio not available:', e);
      return null;
    }
  }
  // Some browsers suspend the context until user interaction
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

function playTone({ freq, duration = 0.2, type = 'sine', startGain = 0.18, attack = 0.01, release = 0.15, delay = 0 }) {
  const ac = getCtx();
  if (!ac || muted) return;
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(startGain, t0 + attack);
  gain.gain.setTargetAtTime(0, t0 + duration, release / 3);
  osc.connect(gain).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + duration + release + 0.05);
}

export function playCorrect() {
  // Gentle two-note ascending: C5 -> E5
  playTone({ freq: 523.25, duration: 0.12, type: 'triangle', startGain: 0.15 });
  playTone({ freq: 659.25, duration: 0.18, type: 'triangle', startGain: 0.15, delay: 0.1 });
}

export function playOpenedCorrect() {
  // Warm major triad with bell-like timbre: C5, E5, G5 + a sparkle high note
  playTone({ freq: 523.25, duration: 0.45, type: 'triangle', startGain: 0.13, release: 0.4 });
  playTone({ freq: 659.25, duration: 0.45, type: 'triangle', startGain: 0.11, release: 0.4, delay: 0.05 });
  playTone({ freq: 783.99, duration: 0.5,  type: 'triangle', startGain: 0.10, release: 0.5, delay: 0.1 });
  // Sparkle: high octave overlay
  playTone({ freq: 1046.5, duration: 0.18, type: 'sine', startGain: 0.07, release: 0.3, delay: 0.18 });
}

export function playIncorrect() {
  // Soft low descending: G3 -> E3
  playTone({ freq: 196.0, duration: 0.18, type: 'triangle', startGain: 0.13, release: 0.18 });
  playTone({ freq: 164.81, duration: 0.22, type: 'triangle', startGain: 0.13, release: 0.22, delay: 0.13 });
}

export function playClick() {
  playTone({ freq: 880, duration: 0.04, type: 'sine', startGain: 0.06, attack: 0.001, release: 0.05 });
}

export function setMuted(value) {
  muted = !!value;
  try { localStorage.setItem('quiz_muted', muted ? '1' : '0'); } catch {}
}

export function isMuted() {
  if (muted) return true;
  try { return localStorage.getItem('quiz_muted') === '1'; } catch { return false; }
}

// Initialize muted state from localStorage
muted = isMuted();
